export default defineNuxtRouteMiddleware(async (to, from) => {
  const { user } = useDirectusAuth()
  const nuxtApp = useNuxtApp()
  const { locale, setLocale } = nuxtApp.$i18n

  if (
    ['admin', 'super-administrator'].includes(user.value?.role) &&
    to.fullPath.includes('/portal') &&
    !to.fullPath.startsWith('/nl/portal')
  ) {
    // Only replace if path starts with a language code
    if (to.fullPath.match(/^\/[a-z]{2}\//)) {
      return navigateTo('/nl' + to.fullPath.replace(/^\/[a-z]{2}/, ''))
    }
    // Otherwise just prepend /nl
    return navigateTo('/nl' + to.fullPath)
  }
})
